module.exports = __webpack_public_path__ + "assets/img/maintain.534b75d3.png";